export interface ProgressBarProps {
  value: number;
  max?: number;
  label?: string;
  valueLabel?: string;
  muted?: boolean;
  className?: string;
  'data-testid'?: string;
}

/**
 * Horizontal progress bar (reference: Persona Alignment Score).
 */
export function ProgressBar({
  value,
  max = 100,
  label,
  valueLabel,
  muted = false,
  className = '',
  'data-testid': dataTestId,
}: ProgressBarProps) {
  const clamped = Math.min(max, Math.max(0, value));
  const percent = max > 0 ? (clamped / max) * 100 : 0;

  return (
    <div data-testid={dataTestId ?? 'design-system-progress-bar'} className={className}>
      {label || valueLabel ? (
        <div className="mb-2 flex items-center justify-between text-sm">
          {label ? <span className="text-secondary">{label}</span> : <span />}
          {valueLabel ? <span className="font-medium text-primary">{valueLabel}</span> : null}
        </div>
      ) : null}
      <div
        className="ds-progress-track"
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={max}
      >
        <div
          className={muted ? 'ds-progress-fill-muted' : 'ds-progress-fill'}
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}
